var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLumeFeatureTranscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 16.6667H17.5",
    stroke: "var(--stroke-0, #B59292)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6467 3.01833C13.9784 2.68659 14.4283 2.50022 14.8975 2.50022C15.3667 2.50022 15.8166 2.68659 16.1483 3.01833C16.4801 3.35008 16.6664 3.80001 16.6664 4.26917C16.6664 4.73832 16.4801 5.18826 16.1483 5.52L6.14 15.5292C5.94175 15.7274 5.69669 15.8724 5.4275 15.9508L3.03417 16.6492C2.96246 16.6701 2.88645 16.6713 2.81409 16.6528C2.74173 16.6343 2.67569 16.5966 2.62287 16.5438C2.57006 16.491 2.53241 16.4249 2.51387 16.3526C2.49533 16.2802 2.49659 16.2042 2.5175 16.1325L3.21583 13.7392C3.29435 13.4703 3.43937 13.2255 3.6375 13.0275L13.6467 3.01833Z",
    stroke: "var(--stroke-0, #B59292)",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumeFeatureTranscribe);
export default __webpack_public_path__ + "static/media/lume-feature-transcribe.c85eeccfca6c9f3d9c0d3c9cafd8b071.svg";
export { ForwardRef as ReactComponent };